var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcListTodo = function SvgIcListTodo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M8.667 3.333H14M8.667 8H14M8.667 12.667H14M2 11.333l1.333 1.334L6 10M5.333 2.667H2.667A.667.667 0 0 0 2 3.333V6c0 .368.298.667.667.667h2.666A.667.667 0 0 0 6 6V3.333a.667.667 0 0 0-.667-.666"
  })));
};
export default SvgIcListTodo;